/**
 * @generated SignedSource<<9c533380dfb38a108d893f8dc4d7adbe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CurrentUserProvider_data$data = {
  readonly viewer: {
    readonly canPublish: boolean;
    readonly email: string;
    readonly id: string;
    readonly itemsPerPage: number;
    readonly name: string;
  } | null;
  readonly " $fragmentType": "CurrentUserProvider_data";
};
export type CurrentUserProvider_data$key = {
  readonly " $data"?: CurrentUserProvider_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"CurrentUserProvider_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurrentUserProvider_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "itemsPerPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canPublish",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "47bdc8c63b5f774507e56c3c695c6144";

export default node;
